import HCLTreeVertex from '../HCLTreeVertex';
import HCLTreeVertexValue from "../HCLTreeVertexValue/HCLTreeVertexValue";
import Outcome from "../HCLTreeVertexValue/Outcome";
import ProxyTypes from "../HCLTreeVertexValue/ProxyTypes";
import ReferenceTypes from "../HCLTreeVertexValue/ReferenceTypes";

abstract class FaultTreeVertex extends HCLTreeVertex {
  private refType: ReferenceTypes;

  /**
   * @param {string} key
   * @param {HCLTreeVertexValue} value
   * @param {ReferenceTypes} refType
   */
  protected constructor(key: string, value: HCLTreeVertexValue, refType: ReferenceTypes) {
    super(key, value);
    this.refType = refType;
  }

  /**
   * @return {ReferenceTypes}
   */
  public getReferenceType(): ReferenceTypes {
    return this.refType;
  }

  /**
   * @override
   * @return {OutcomeJSON}
   */
  toReferenceJSON() {
    /**
     * TODO: Check how to handle tree ID
     * TODO: Check how to handle path
     */
    return new Outcome(this.getKey(), this.getReferenceType(), this.getGraph().getModelTreeId(), '', ProxyTypes.EVENT_REFERENCE).toJSON();
  }

}

export default FaultTreeVertex;
